export enum ExternalTransferReducerActions {
  SET_BANKNAMES_WITH_EXPIRED_SYNC,
  SET_DATA_FOR_CONFIRMATION,
  SET_INITIAL_DROPDOWN,
  SET_TRANSFER_DATA,
  SET_SETTINGS,
  SET_TRANSFER_TYPES,
  SHOW_DIALOG,
  HIDE_DIALOG,
  RESET,
}
